export function getAttachmentType(
  mimeType
) {
  if (
    mimeType?.startsWith("image/")
  ) {
    return "m.image";
  }

  if (
    mimeType?.startsWith("video/")
  ) {
    return "m.video";
  }

  return "m.file";
}


export async function uploadMatrixFile(
  client,
  file
) {
  if (!client) {
    throw new Error(
      "Matrix client не создан"
    );
  }

  if (!file) {
    throw new Error(
      "Файл не выбран"
    );
  }

  const upload =
    await client.uploadContent(
      file,
      {
        type:
          file.type ||
          "application/octet-stream",

        name: file.name,
      }
    );

  const mxcUrl =
    upload?.content_uri;

  if (!mxcUrl) {
    throw new Error(
      "Matrix не вернул media URL"
    );
  }

  return mxcUrl;
}


export function getImageDimensions(
  file
) {
  return new Promise(
    (resolve) => {
      const image =
        new Image();

      const url =
        URL.createObjectURL(file);

      image.onload = () => {
        URL.revokeObjectURL(url);

        resolve({
          width:
            image.naturalWidth,

          height:
            image.naturalHeight,
        });
      };

      image.onerror = () => {
        URL.revokeObjectURL(url);

        resolve({
          width: undefined,
          height: undefined,
        });
      };

      image.src = url;
    }
  );
}


export function getVideoDimensions(
  file
) {
  return new Promise(
    (resolve) => {
      const video =
        document.createElement(
          "video"
        );

      const url =
        URL.createObjectURL(file);

      video.onloadedmetadata =
        () => {
          URL.revokeObjectURL(url);

          resolve({
            width:
              video.videoWidth,

            height:
              video.videoHeight,

            duration:
              Number.isFinite(
                video.duration
              )
                ? Math.round(
                    video.duration *
                      1000
                  )
                : undefined,
          });
        };

      video.onerror = () => {
        URL.revokeObjectURL(url);

        resolve({
          width: undefined,
          height: undefined,
          duration: undefined,
        });
      };

      video.src = url;
    }
  );
}